import React from "react";
import { GiftIcon, CheckIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { CtaButton } from "../CtaButton";
import { bonuses } from "../../data/content";
export function Bonuses() {
  return <section className="px-4 py-16 md:py-24" aria-labelledby="bonuses-title" data-id="element-67" data-mp="1clpk2p8rc6uk">
      <div className="mx-auto max-w-5xl" data-id="element-68" data-mp="18km6yai3gox1">
        <SectionHeading eyebrow="Exclusive bonuses — included free" title={<span id="bonuses-title" data-id="element-70" data-mp="257r2gyhk94w8">
              Today you'll also receive these <em className="text-brand-600" data-id="element-71" data-mp="20c1ymiyid1u4">5 professional bonuses</em>
            </span>} data-id="element-69" data-mp="18hhwive1cwxx" />
        <div className="mx-auto mt-6 flex max-w-md items-center justify-center gap-3 rounded-2xl bg-gold/20 px-5 py-4 text-center" data-id="element-72" data-mp="1w7lzr1nbauoe">
          <GiftIcon className="h-6 w-6 shrink-0 text-brand-900" aria-hidden="true" data-id="element-73" data-mp="ku08naxw6j08" />
          <p className="text-[15px] font-semibold text-ink" data-id="element-74" data-mp="krxce965btn2">
            Bonus value: <span className="font-black" data-id="element-75" data-mp="ftca847c2zvz">USD $147</span> — included with your USD $27 purchase
          </p>
        </div>

        <div className="mt-12 space-y-14 md:space-y-20" data-id="element-76" data-mp="1erk9wrz97w2r">
          {bonuses.map((b, i) => <article key={b.number} className={`md:grid md:grid-cols-2 md:items-center md:gap-12 ${i % 2 === 1 ? "md:[&>*:first-child]:order-2" : ""}`} data-id="element-77" data-mp="1jqnhaj2piedw" data-mpi={i}>
              <div className="-mx-4 sm:mx-0" data-id="element-78" data-mp="1aq8m8rzxxkx7">
                <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="w-full sm:rounded-3xl" width={1254} height={1254} loading="lazy" data-id="element-79" data-mp="w2ngeqbol7ll" />
              </div>
              <div className="mt-6 md:mt-0" data-id="element-80" data-mp="r3klhypf0hrc">
                <div className="flex flex-wrap items-center gap-3" data-id="element-81" data-mp="r4c6ygpasz3w">
                  <span className="rounded-lg bg-brand-700 px-3 py-1 text-sm font-extrabold uppercase tracking-wider text-white" data-id="element-82" data-mp="d5cib91sck7q">
                    Bonus #{b.number}
                  </span>
                  <span className="text-sm font-semibold text-muted" data-id="element-83" data-mp="2jstm66yrtqom">
                    Value: <s data-id="element-84" data-mp="2f23jj1hqc1xm">USD ${b.value}</s> <span className="font-extrabold text-go" data-id="element-85" data-mp="2f1lbz8pma1ae">FREE today</span>
                  </span>
                </div>
                <h3 className="mt-3 font-serif text-[1.75rem] font-black leading-tight text-ink md:text-4xl" data-id="element-86" data-mp="2b11eu551mxo9">{b.title}</h3>
                <p className="mt-3 text-[16px] leading-relaxed text-muted" data-id="element-87" data-mp="25z2dt1ws0cuh">{b.description}</p>
                <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-88" data-mp="32qmob71klwky">
                  {b.items.map(item => <li key={item} className="flex items-start gap-2 text-[15px] leading-snug text-ink" data-id="element-89" data-mp="2ynq6vjnro6il">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-go" strokeWidth={3} aria-hidden="true" data-id="element-90" data-mp="2tskk6imjintg" />
                      {item}
                    </li>)}
                </ul>
                <p className="mt-5 border-l-4 border-brand-500 pl-4 text-[16px] font-semibold leading-snug text-brand-900" data-id="element-91" data-mp="1dchnm4s1e6si">
                  {b.closing}
                </p>
              </div>
            </article>)}
        </div>

        <div className="mt-14" data-id="element-92" data-mp="188p6ykcxwcu0">
          <CtaButton label="Yes, I want the 5 bonuses" data-id="element-93" data-mp="187xfnlqdl19j" />
        </div>
      </div>
    </section>;
}